import React, { FunctionComponent } from "react";
import { Link } from "react-router-dom";

import { DetailedCartItem } from "../../../../../../../../../context/CartContext/CartContext.api.types";
import { Icon } from "../../../../../../../../Icon";

// Styles
import "./Header.scss";

type Props = {
  cartDetailedItem: DetailedCartItem;
  onDelete: () => void;
  onEdit: (cartDetailedItem: DetailedCartItem) => void;
};

const Header: FunctionComponent<Props> = ({
  cartDetailedItem,
  onDelete,
  onEdit,
}) => (
  <header className="header">
    <div className="header__information">
      <p className="header__information__quantity">
        {cartDetailedItem.quantity}
      </p>
      <div>
        <p className="header__information__title">
          {cartDetailedItem.product.title}
        </p>
        {cartDetailedItem.product.sku ? (
          <p className="header__information__sku">
            {cartDetailedItem.product.sku}
          </p>
        ) : null}
      </div>
    </div>
    <div className="header__actions">
      <div
        className="header__actions__action-container"
        onClick={() => onEdit(cartDetailedItem)}
      >
        <Icon
          iconName="edit-icon-squared"
          className="header__actions__action"
        />
      </div>
      <div onClick={onDelete}>
        <Icon iconName="trash_cart" className="header__actions__action" />
      </div>
    </div>
  </header>
);

export default Header;
